import React from "react";
// import TwoColFourStories from "../../../../arrow/components/Rows/TwoColFourStory";
import { object } from "prop-types";

export const ArrowTwoColFourStories = ({ collection }) => {
  const config = {
    buttonText: `${collection.name} News`,
  };
  // return <TwoColFourStories collection={collection} config={config} />;
  return null;
};

ArrowTwoColFourStories.propTypes = {
  collection: object,
};

ArrowTwoColFourStories.storyLimit = 4;
